import { Flex, Icon, VStack, Text } from '@cad-arc';
import { getUniversalSearchLabel } from '../../../common/helpers/get-usx-labels';
import { useEnabledFeatures } from '../../../common/hooks/enabled-features';

export function DexNoResults() {
    const { dexNextEnabled } = useEnabledFeatures();

    return (
        <Flex
            h="100%"
            w="100%"
            justifyContent="center"
            alignItems="center"
            data-testid="fr-dex-tab-no-results"
        >
            <VStack>
                <Icon icon="Dex" size="lg" color="icon.default" />
                <Text>{`No ${getUniversalSearchLabel(dexNextEnabled)} Activity`}</Text>
            </VStack>
        </Flex>
    );
}
